import { useCallback } from 'react'
import api from '../../lib/commons/api'
import {
  SprintBacklogItemRepository,
  SaveSprintBacklogItemInput,
} from '../../applications/ports/sprintBacklogItemRepository'

export const useSprintBacklogItemRepository =
  (): SprintBacklogItemRepository => {
    const save = useCallback(async (input: SaveSprintBacklogItemInput) => {
      if (input.added.length === 0 && input.deleted.length === 0) {
        return
      }

      await api.functional.request(
        'POST',
        '/api/v1/projects/scrums/sprint_backlogs/batch',
        {
          sprintBacklogItems: [],
          sprintPlans: input,
        }
      )
    }, [])

    return {
      save,
    }
  }
